"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useHoverWithTransition = require("b2b-components/hooks/useHoverWithTransition");
var _common = require("b2b-components/theme/common");
var _device = require("b2b-components/utils/device");
var _CopyableText = require("../CopyableText");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var WithContainer = function WithContainer(props) {
  var children = props.children,
    text = props.text,
    deviceType = props.deviceType,
    buttonVisibility = props.buttonVisibility,
    buttonTouchscreenVisibility = props.buttonTouchscreenVisibility;
  var isCopyButtonDesktopAlwaysVisible = (0, _device.isDesktop)(deviceType) && buttonVisibility === _CopyableText.COPYABLE_TEXT_BUTTON_VISIBILITY.always;
  var isCopyButtonTouchscreenAlwaysVisible = !(0, _device.isDesktop)(deviceType) && buttonTouchscreenVisibility === _CopyableText.COPYABLE_TEXT_BUTTON_VISIBILITY.always;
  var isCopyButtonInitialVisible = isCopyButtonDesktopAlwaysVisible || isCopyButtonTouchscreenAlwaysVisible;
  var _useHoverWithTransiti = (0, _useHoverWithTransition.useHoverWithTransition)(isCopyButtonInitialVisible),
    onCopyableTextMouseEnter = _useHoverWithTransiti.onMouseEnter,
    onCopyableTextMouseLeave = _useHoverWithTransiti.onMouseLeave,
    onCopyButtonTransitionEnd = _useHoverWithTransiti.onTransitionEnd,
    isCopyButtonVisible = _useHoverWithTransiti.isVisible,
    isTransitionActive = _useHoverWithTransiti.isTransitionActive,
    setCopyButtonVisibility = _useHoverWithTransiti.setVisibility;
  var isTooltipEnabled = isCopyButtonVisible && !isTransitionActive;
  var getTooltipText = function getTooltipText(status) {
    if (status === _common.COPY_STATUS.success) {
      return text.tooltipCopySuccessText;
    }
    if (status === _common.COPY_STATUS.failure) {
      return text.tooltipCopyFailText;
    }
    return text.tooltipText;
  };
  (0, _react.useEffect)(function () {
    return setCopyButtonVisibility(isCopyButtonInitialVisible);
  }, [buttonTouchscreenVisibility, buttonVisibility, deviceType, isCopyButtonInitialVisible, setCopyButtonVisibility]);
  return /*#__PURE__*/_react["default"].createElement(_CopyableText.CopyableText, (0, _extends2["default"])({}, props, {
    isCopyButtonVisible: isCopyButtonVisible,
    isTooltipEnabled: isTooltipEnabled,
    getTooltipText: getTooltipText,
    onCopyableTextMouseEnter: onCopyableTextMouseEnter,
    onCopyableTextMouseLeave: onCopyableTextMouseLeave,
    onCopyButtonTransitionEnd: onCopyButtonTransitionEnd
  }), children);
};
exports.WithContainer = WithContainer;